import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import OfferCard from './OfferCard';
import { LanguageContext } from '../LanguageContext';

import imgOmra1 from '../img/off1.jpg'; 
import imgOmra2 from '../img/off2.jpg'; 
import imgOmra3 from '../img/off3.jpg'; 
import imgOmra4 from '../img/off4.jpg'; 
import imgOmra5 from '../img/off5.jpeg'; 


function Offers() {
  const { language } = useContext(LanguageContext);
  const navigate = useNavigate();

  const content = {
    fr: {
      title: 'Nos Offres Omra',
      offers: [
        {
          thumbImage: imgOmra1,
          title: 'Omra Septembre 2025',
          dates: 'Du 02/09 au 16/09/25',
          airline: 'Saudi Airlines',
          duration: '15 Jours',
          price: 'À partir de 2950 CHF',
          link: 'details.html',
          tag: null,
          soon: false,
        },
        {
          thumbImage: imgOmra2,
          title: 'Omra Octobre 2025',
          dates: 'Du 02/10 au 16/10/25',
          airline: 'Saudi Airlines',
          duration: '15 Jours',
          price: 'À partir de 2950 CHF',
          link: 'details.html',
          tag: null,
          soon: false,
        },
        {
          thumbImage: imgOmra3,
          title: 'Omra Novembre 2025',
          dates: 'Du 02/11 au 16/11/25',
          airline: 'Saudi Airlines',
          duration: '15 Jours',
          price: 'À partir de 2950 CHF',
          link: 'details.html',
          tag: null,
          soon: false,
        },
        {
          thumbImage: imgOmra4,
          title: 'Omra Décembre 2025',
          dates: 'Du 02/12 au 16/12/25',
          airline: 'Saudi Airlines',
          duration: '15 Jours',
          price: 'À partir de 2950 CHF',
          link: 'details.html',
          tag: null,
          soon: false,
        },
        {
          thumbImage: imgOmra5,
          title: 'Omra Fin Décembre 2025 - Janvier 2026',
          dates: 'Du 22/12/25 au 02/01/26',
          airline: 'Saudi Airlines',
          duration: '12 Jours',
          price: 'À partir de 2750 CHF',
          link: 'details.html',
          tag: null,
          soon: false,
        },
      ],
    },
    ar: {
      title: 'عروض العمرة',
      offers: [
        {
          thumbImage: imgOmra1,
          title: 'عمرة سبتمبر 2025',
          dates: 'من 02/09 إلى 16/09/25',
          airline: 'الخطوط السعودية',
          duration: '15 يومًا',
          price: 'ابتداءً من 2950 فرنك',
          link: 'details.html',
          tag: null,
          soon: false,
        },
        {
          thumbImage: imgOmra2,
          title: 'عمرة أكتوبر 2025',
          dates: 'من 02/10 إلى 16/10/25',
          airline: 'الخطوط السعودية',
          duration: '15 يومًا',
          price: 'ابتداءً من 2950 فرنك',
          link: 'details.html',
          tag: null,
          soon: false,
        },
        {
          thumbImage: imgOmra3,
          title: 'عمرة نوفمبر 2025',
          dates: 'من 02/11 إلى 16/11/25',
          airline: 'الخطوط السعودية',
          duration: '15 يومًا',
          price: 'ابتداءً من 2950 فرنك',
          link: 'details.html',
          tag: null,
          soon: false,
        },
        {
          thumbImage: imgOmra4,
          title: 'عمرة ديسمبر 2025',
          dates: 'من 02/12 إلى 16/12/25',
          airline: 'الخطوط السعودية',
          duration: '15 يومًا',
          price: 'ابتداءً من 2950 فرنك',
          link: 'details.html',
          tag: null,
          soon: false,
        },
        {
          thumbImage: imgOmra5,
          title: 'عمرة نهاية ديسمبر 2025 - يناير 2026',
          dates: 'من 22/12/25 إلى 02/01/26',
          airline: 'الخطوط السعودية',
          duration: '12 يومًا',
          price: 'ابتداءً من 2750 فرنك',
          link: 'details.html',
          tag: null,
          soon: false,
        },
      ],
    },
  };

  const handleOfferClick = (offer) => {
    navigate(`/reservation/${offer.title}`, { state: { offer } });
  };

  return (
    <section id="offres" className="py-20 bg-gradient-to-r from-blue-50 via-green-100 to-blue-50">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center hover:text-green-600 transition-colors duration-300">
          {content[language].title}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {content[language].offers.map((offer, index) => (
            <div key={index} onClick={() => handleOfferClick(offer)}>
              <OfferCard offer={offer} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Offers;